import { useTiktokUserKeywordsQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { useTiktokTagsAnalyticsFilter } from '@anytag/shared-organisms';
import { Template } from './template';

export const TiktokKeywordAnalytics = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Tiktok Keyword Analytics',
    appHeader: 'appHeader.Tiktok Keyword Analytics'
  });
  const { filter, setFilter, countryId } = useTiktokTagsAnalyticsFilter();
  const { data, loading, called } = useTiktokUserKeywordsQuery({
    variables: { countryId },
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ tiktokUserKeywords }) => {
      const isValidHashtag = tiktokUserKeywords?.keywords?.findIndex((keyword) => keyword.id === filter.tagId) !== -1;

      if (!filter.tagId || !isValidHashtag) {
        setFilter({ tagId: tiktokUserKeywords?.keywords?.at(0)?.id || '' }, { replace: true });
      }
    }
  });

  return (
    <RenderDataWithFallback loading={loading && !called} hasNoData={!filter.date}>
      <Template keywords={data?.tiktokUserKeywords.keywords || []} />
    </RenderDataWithFallback>
  );
};
